import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, n = /* @__PURE__ */ l("path", {
  fill: "#fff",
  d: "M10 0h10v2.5l-1.25 1.25L20 5v2.5l-1.25 1.25L20 10v2.5l-1.25 1.25L20 15v2.5l-10 1.25L0 17.5V15l1.25-1.25L0 12.5V10z"
}, null, -1), s = /* @__PURE__ */ l("path", {
  fill: "#D80027",
  d: "M8.75 2.5H20V5H8.75zm0 5H20V10H10zM0 12.5h20V15H0zm0 5h20V20H0z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M0 0h10v10H0z"
}, null, -1), H = /* @__PURE__ */ l("path", {
  fill: "#fff",
  d: "M7.305 9.492 9.53 7.891H6.797l2.226 1.601-.859-2.617zm-3.164 0 2.226-1.601H3.633l2.226 1.601L5 6.875zm-3.164 0 2.226-1.601H.47l2.226 1.601-.86-2.617zm6.328-3.164L9.53 4.727H6.797l2.226 1.601-.859-2.617zm-3.164 0 2.226-1.601H3.633l2.226 1.601L5 3.711zm-3.164 0 2.226-1.601H.47l2.226 1.601-.86-2.617zm6.328-3.203L9.53 1.523H6.797l2.226 1.602L8.164.508zm-3.164 0 2.226-1.602H3.633l2.226 1.602L5 .508zm-3.164 0 2.226-1.602H.47l2.226 1.602-.86-2.617z"
}, null, -1), c = [
  n,
  s,
  h,
  H
];
function d(m, z) {
  return t(), e("svg", o, [...c]);
}
const i = { render: d };
export {
  i as default,
  d as render
};
